(function () {
  'use strict';

  // ---------- Pure calc (unit-tested in Node) ----------
  function compute(state) {
    var spb = (state.sqftPerBox > 0) ? state.sqftPerBox : 20;
    var priceCents = state.priceCents || 0;

    // Direct box mode: exact box count — no waste, no rounding up to an extra box
    if (state.mode === 'boxes') {
      var nb = Math.floor(parseFloat(state.boxes) || 0);
      var ppsBox = priceCents / 100;
      if (!(nb > 0)) {
        return {
          valid: false, desiredSqft: 0, effectiveSqft: 0, boxes: 0,
          totalSqft: 0, quantity: 0, subtotal: 0, was: null,
          pricePerSqft: ppsBox, sqftPerBox: spb, capped: false
        };
      }
      var tsBox = nb * spb;
      return {
        valid: true, desiredSqft: tsBox, effectiveSqft: tsBox, boxes: nb,
        totalSqft: tsBox, quantity: Math.round(tsBox), subtotal: tsBox * ppsBox,
        was: state.compareCents ? tsBox * (state.compareCents / 100) : null,
        pricePerSqft: ppsBox, sqftPerBox: spb, capped: false
      };
    }

    var desiredSqft = 0;

    if (state.mode === 'room') {
      var rooms = state.rooms || [];
      for (var i = 0; i < rooms.length; i++) {
        var w = parseFloat(rooms[i].w) || 0;
        var l = parseFloat(rooms[i].l) || 0;
        if (w > 0 && l > 0) desiredSqft += w * l;
      }
    } else {
      desiredSqft = parseFloat(state.sqft) || 0;
    }

    var MAX = 100000, capped = false;
    if (desiredSqft > MAX) { desiredSqft = MAX; capped = true; }

    if (!(desiredSqft > 0)) {
      return {
        valid: false, desiredSqft: 0, effectiveSqft: 0, boxes: 0,
        totalSqft: 0, quantity: 0, subtotal: 0, was: null,
        pricePerSqft: priceCents / 100, sqftPerBox: spb, capped: false
      };
    }

    var effectiveSqft = state.waste ? desiredSqft * 1.10 : desiredSqft;
    var boxes = Math.ceil(effectiveSqft / spb);
    var totalSqft = boxes * spb;
    var quantity = Math.round(totalSqft);
    var pricePerSqft = priceCents / 100;
    var subtotal = totalSqft * pricePerSqft;
    var was = state.compareCents ? totalSqft * (state.compareCents / 100) : null;

    return {
      valid: true, desiredSqft: desiredSqft, effectiveSqft: effectiveSqft,
      boxes: boxes, totalSqft: totalSqft, quantity: quantity,
      subtotal: subtotal, was: was, pricePerSqft: pricePerSqft,
      sqftPerBox: spb, capped: capped
    };
  }

  // ---------- Node export for tests ----------
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { compute: compute };
  }

  // ---------- Browser-only below ----------
  if (typeof document === 'undefined') return;

  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); }
  function round2(n) { return Math.round(n * 100) / 100; }

  function initCalc(root) {
    if (root.__z4init) return;
    root.__z4init = true;

    var state = {
      mode: 'sqft',
      sqft: '',
      rooms: [{ w: '', l: '' }],
      waste: true,
      sqftPerBox: parseFloat(root.getAttribute('data-sqft-per-box')) || 20,
      priceCents: parseFloat(root.getAttribute('data-price-cents')) || 0,
      compareCents: parseFloat(root.getAttribute('data-compare-cents')) || 0
    };
    var step = 1;

    var qs = function (s) { return root.querySelector(s); };
    var qsa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var qtyEl = qs('[data-z4-qty]');
    var totalEl = qs('[data-z4-totalsqft]');
    var boxesHiddenEl = qs('[data-z4-boxes]');
    var sqftIn = qs('[data-z4-sqft]');
    var wasteIn = qs('[data-z4-waste]');
    var roomsWrap = qs('[data-z4-rooms]');
    var roomTotalEl = qs('[data-z4-roomtotal]');
    var hintEl = qs('[data-z4-hint]');
    var roomTpl = qs('[data-z4-room-template]');

    function showStep(n) {
      step = n;
      qsa('[data-z4-step]').forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-z4-step') === String(n));
      });
      qsa('[data-z4-dot]').forEach(function (d) {
        var dn = parseInt(d.getAttribute('data-z4-dot'), 10);
        d.classList.toggle('is-on', dn === n);
        d.classList.toggle('is-done', dn < n);
      });
      if (n === 3) renderResult();
    }

    function setMode(mode) {
      state.mode = mode;
      qsa('[data-z4-mode]').forEach(function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-z4-mode') === mode);
      });
      qsa('[data-z4-panel]').forEach(function (p) {
        p.classList.toggle('is-hidden', p.getAttribute('data-z4-panel') !== mode);
      });
    }

    function renderRooms() {
      roomsWrap.innerHTML = '';
      state.rooms.forEach(function (room, idx) {
        var node = roomTpl.content.firstElementChild.cloneNode(true);
        node.querySelector('[data-z4-roomn]').textContent = (idx + 1);
        var wEl = node.querySelector('[data-z4-w]');
        var lEl = node.querySelector('[data-z4-l]');
        wEl.value = room.w;
        lEl.value = room.l;
        wEl.addEventListener('input', function () { state.rooms[idx].w = wEl.value; updateRoomTotal(); });
        lEl.addEventListener('input', function () { state.rooms[idx].l = lEl.value; updateRoomTotal(); });
        var del = node.querySelector('[data-z4-roomdel]');
        del.style.display = state.rooms.length > 1 ? '' : 'none';
        del.addEventListener('click', function () {
          state.rooms.splice(idx, 1);
          renderRooms();
          updateRoomTotal();
        });
        roomsWrap.appendChild(node);
      });
    }

    function updateRoomTotal() {
      var r = compute({ mode: 'room', rooms: state.rooms, waste: false,
                        sqftPerBox: state.sqftPerBox, priceCents: 0, compareCents: 0 });
      roomTotalEl.innerHTML = 'Total area: <strong>' + round2(r.desiredSqft) + ' sq ft</strong>';
    }

    function syncCart(r) {
      if (qtyEl) qtyEl.value = r.valid ? r.quantity : 0;
      if (totalEl) totalEl.value = r.valid ? r.totalSqft.toFixed(2) : '0';
      if (boxesHiddenEl) boxesHiddenEl.value = r.valid ? r.boxes : 0;
    }

    function renderResult() {
      var r = compute(state);
      syncCart(r);
      var boxesOut = qs('[data-z4-r-boxes]');
      var covOut = qs('[data-z4-r-cov]');
      var subOut = qs('[data-z4-r-subtotal]');
      var wasOut = qs('[data-z4-r-was]');
      var perOut = qs('[data-z4-r-per]');
      if (boxesOut) boxesOut.textContent = r.boxes;
      if (covOut) covOut.textContent = 'Covers ' + round2(r.totalSqft) + ' sq ft' + (state.waste ? ' (incl. 10% waste)' : '');
      if (subOut) subOut.textContent = money(r.subtotal);
      if (wasOut) {
        if (r.was) { wasOut.textContent = money(r.was); wasOut.classList.remove('is-hidden'); }
        else { wasOut.classList.add('is-hidden'); }
      }
      if (perOut) perOut.textContent = money(r.pricePerSqft) + '/sq ft';
    }

    function hasMeasurement() { return compute(state).valid; }

    // events
    qsa('[data-z4-mode]').forEach(function (b) {
      b.addEventListener('click', function () { setMode(b.getAttribute('data-z4-mode')); });
    });
    if (sqftIn) sqftIn.addEventListener('input', function () { state.sqft = sqftIn.value; });
    if (wasteIn) wasteIn.addEventListener('change', function () { state.waste = wasteIn.checked; });

    var plusBtn = qs('[data-z4-plus]');
    var minusBtn = qs('[data-z4-minus]');
    if (plusBtn) plusBtn.addEventListener('click', function () {
      var v = (parseFloat(state.sqft) || 0) + state.sqftPerBox;
      state.sqft = String(v);
      if (sqftIn) sqftIn.value = state.sqft;
    });
    if (minusBtn) minusBtn.addEventListener('click', function () {
      var v = Math.max(0, (parseFloat(state.sqft) || 0) - state.sqftPerBox);
      state.sqft = v > 0 ? String(v) : '';
      if (sqftIn) sqftIn.value = state.sqft;
    });

    var addRoomBtn = qs('[data-z4-addroom]');
    if (addRoomBtn) addRoomBtn.addEventListener('click', function () {
      state.rooms.push({ w: '', l: '' });
      renderRooms();
      updateRoomTotal();
    });

    qsa('[data-z4-next]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (step === 2 && !hasMeasurement()) {
          if (hintEl) hintEl.classList.remove('is-hidden');
          return;
        }
        if (hintEl) hintEl.classList.add('is-hidden');
        showStep(Math.min(3, step + 1));
      });
    });
    qsa('[data-z4-back]').forEach(function (b) {
      b.addEventListener('click', function () { showStep(Math.max(1, step - 1)); });
    });

    // Direct buy-by-the-box — skips the wizard; reuses compute() via a synthetic sqft state
    var boxQtyEl = qs('[data-z4-boxqty]');
    function boxResult() {
      var n = Math.max(1, Math.floor(parseFloat(boxQtyEl.value) || 1));
      return compute({ mode: 'boxes', boxes: n,
                       sqftPerBox: state.sqftPerBox, priceCents: state.priceCents, compareCents: 0 });
    }
    function renderBox() {
      if (!boxQtyEl) return null;
      var r = boxResult();
      var covEl = qs('[data-z4-boxcov]');
      var priceEl = qs('[data-z4-boxprice]');
      if (covEl) covEl.textContent = round2(r.totalSqft) + ' sq ft';
      if (priceEl) priceEl.textContent = money(r.subtotal);
      return r;
    }
    if (boxQtyEl) {
      boxQtyEl.addEventListener('input', renderBox);
      var boxMinus = qs('[data-z4-boxminus]');
      var boxPlus = qs('[data-z4-boxplus]');
      if (boxMinus) boxMinus.addEventListener('click', function () {
        boxQtyEl.value = Math.max(1, (parseInt(boxQtyEl.value, 10) || 1) - 1); renderBox();
      });
      if (boxPlus) boxPlus.addEventListener('click', function () {
        boxQtyEl.value = (parseInt(boxQtyEl.value, 10) || 1) + 1; renderBox();
      });
      var boxAdd = qs('[data-z4-boxadd]');
      if (boxAdd) boxAdd.addEventListener('click', function () {
        // Write the shared hidden line-item fields to THIS box qty, then let the form submit
        syncCart(renderBox());
      });
      renderBox();
    }

    // init
    setMode('sqft');
    renderRooms();
    updateRoomTotal();
    showStep(1);
    syncCart({ valid: false, quantity: 0, totalSqft: 0, boxes: 1 });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('flooring-calculator'), initCalc);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
